// extracted by mini-css-extract-plugin
export default {"btnCTA":"Button_btnCTA__3wKx4","btnAlt":"Button_btnAlt__+7JpL"};